<template>
  <v-card
    class="mt-5"
    outlined
    rounded="lg"
  >
    <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr>
            <th
              v-for="(item, index) in headers"
              :key="index"
              class="text-left"
            >
              {{item.text}}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item,index) in loanDistributions"
            :key="index"
          >
            <td>
              {{`${item.person?.firstName} ${item.person?.lastName}`}}
            </td>
            <td>
              {{asMoney(item.affordabilityResults?.grossIncome || 0)}}
            </td>
            <td>
              {{asMoney(+item.affordabilityResults?.totalNonStatutoryDeductions + +item.affordabilityResults?.totalStatutoryDeductions)}}
            </td>
            <td>
              {{asMoney(item.affordabilityResults?.totalDebts || 0)}}
            </td>
            <td>
              {{asMoney(item.affordabilityResults?.totalExpenses || 0)}}
            </td>
            <td>
              {{asMoney(item.affordabilityResults?.finalIncome || 0)}}
            </td>
            <td>
              {{asPercent(item.affordabilityResults?.mainDsrRatio || 0)}}
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <th></th>
            <th
              v-for="(value, key) in summations"
              :key="key"
              class="text-left"
            >
              <span v-if="key === 'averageDsrRatio'">{{asPercent(value)}}</span>
              <span v-else>{{asMoney(value)}}</span>
            </th>
          </tr>
        </tfoot>
      </template>
    </v-simple-table>
  </v-card>
</template>

<script>
import PageMixin from '@/mixins/page.mixin';
export default {
  mixins: [PageMixin],
  data() {
    return {
      /** @type {import('vuetify').DataTableHeader[]}*/
      headers: [
        { text: 'Name', value: 'name', sortable: false },
        { text: 'Gross Income', value: 'income', sortable: false },
        { text: 'Deductions', value: 'deduction', sortable: false },
        { text: 'Debt', value: 'debt', sortable: false },
        { text: 'Expense', value: 'expense', sortable: false },
        {
          text: 'Income After Debt & Expense',
          value: 'incomeAfterDebt',
          sortable: false
        },
        { text: 'Main DSR', value: 'dsr', sortable: false },
      ]
    };
  },
  
  props: {
    loanDistributions: {
      type: Array,
      default: () =>([])
    }
  },
  
  computed: {
    summations: function() {
      return this.loanDistributions.reduce((acc, cur) => {
         const { affordabilityResults } = cur;
         acc.grossIncomeSummation += affordabilityResults.grossIncome; 
         acc.deductionSummation += affordabilityResults.totalNonStatutoryDeductions + affordabilityResults.totalStatutoryDeductions; 
         acc.debtSummation += affordabilityResults.totalDebts;
         acc.expenseSummation += affordabilityResults.totalExpenses;
         acc.finalIncomeSummation += affordabilityResults.finalIncome; 
         acc.averageDsrRatio += affordabilityResults.mainDsrRatio / this.loanDistributions.length;
         return acc; 
      }, {
        grossIncomeSummation: 0,
        deductionSummation: 0,
        debtSummation: 0,
        expenseSummation: 0,
        finalIncomeSummation: 0,   
        averageDsrRatio: 0,
      })
    }
  }
};
</script>

<style lang="scss" scoped></style>
